import { addWeeks, format, isSameDay, isSameYear, isThisWeek, isThisYear, isToday, isWeekend, startOfWeek } from 'date-fns';
import { gql } from 'graphql-request';
import { useCallback, useState } from 'react';
import { useFilminfo } from 'src/lib/client/useFilminfo';

export const KINOTOPPEN_QUERY = gql`
    query ($date: String, $chartType: String, $max: Int) {
        movieQuery {
            getMovieChart(date: $date, chartType: $chartType, max: $max) {
                chartType
                periodStart
                periodEnd
                movieChartItem {
                    pos
                    posPrev
                    admissions
                    admissionsPrev
                    admissionsToDate
                    weeksOnList
                    movie {
                        title
                        mainVersionId
                        premiere
                        sanityImagePosterUrl
                    }
                }
            }
        }
    }
  `;

export type ChartType = "weekend" | "week" | "year" | "opening";

export default function useMovieChart() {
    const [_date, changeDate] = useState(new Date());
    const [_chartType, _setChartType] = useState<ChartType>("weekend");
    const [_showAllMovies, setShowAllMovies] = useState(false);

    const setChartType = useCallback((chartType: ChartType) => {
        if (chartType === "week" && _date) {
            if (isThisWeek(_date, { weekStartsOn: 5 })) {
                changeDate(addWeeks(_date, -1));
            }
        }
        _setChartType(chartType);
    }, [_date]);

    const { fiLoading, fiData } = useFilminfo(KINOTOPPEN_QUERY, { date: format(_date, "yyyy-MM-dd"), chartType: _chartType, max: _showAllMovies ? 1000 : 10 });

    return {
        changeDate,
        setChartType,
        setShowAllMovies,
        isLoading: fiLoading,
        data: fiData?.movieQuery?.getMovieChart,
        date: _date,
        chartType: _chartType,
        showAllMovies: _showAllMovies

    };
}

export function showNextButton(date: Date, chartType: ChartType): boolean {
    let showNextButton = false;
    switch (chartType) {
        case "week":
            showNextButton = !isSameDay(date, addWeeks(new Date(), -1));
            break;
        case "year":
        case "opening":
            showNextButton = !isThisYear(date);
            break;
        default:
            showNextButton = !isToday(date);
    }
    return showNextButton;
}